export default {
  warning:
    'Ten lokal nie jest przypisany do marki. Aby system działał prawidłowo, lokal musi należeć do marki. Dodaj ten lokal do marki.',
  cta: 'Przejdź do marek',
};
